import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { useForm } from "react-hook-form";
import { FormPostSubmissionNoteModel } from "../../../services/api/types/forms/models/FormPostSubmissionNoteModel";
import {
  useAddFormPostSubmissionNoteMutation,
  useVoidFormEntryMutation,
} from "../../../services/api/formsApi";

interface Props {
  onSuccess?: () => void | null;
}

export function useModifyAssessmentEntry(
  entry: SubmittedFormModel | null,
  { onSuccess }: Props,
) {
  const { showNewToast, showErrorToast } = useDisplayToast();

  const [addFormPostSubmissionNote] = useAddFormPostSubmissionNoteMutation();

  const [voidAssessmentEntry, { isLoading: isVoidLoading }] =
    useVoidFormEntryMutation();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormPostSubmissionNoteModel>({
    defaultValues: {
      note: "",
    },
  });

  const submit = handleSubmit(async (data) => {
    try {
      if (!entry) return;

      const body: FormPostSubmissionNoteModel = {
        entry_id: entry.id,
        note: data.note,
      };
      await addFormPostSubmissionNote(body).unwrap();

      if (onSuccess) onSuccess();

      showNewToast({
        title: "Note Submitted",
        message: "The note has been submitted successfully",
        type: "success",
      });
    } catch (error) {
      showErrorToast(error);
    }
  });

  const handleVoidAssessmentEntry = async () => {
    try {
      if (!entry) return;

      await voidAssessmentEntry({ entryId: entry.id }).unwrap();

      if (onSuccess) onSuccess();

      showNewToast({
        title: "Form Voided",
        message: "The form has been marked as voided successfully",
        type: "success",
      });
    } catch (error) {
      showErrorToast(error);
    }
  };

  return {
    control,
    submit,
    isSubmitting,
    handleVoidAssessmentEntry,
    isVoidLoading,
  };
}
